import { amplienceImageLoader } from 'helpers/utils/amplience/imageLoader';
import { cn } from 'helpers/utils/classnames';
import Image from 'next/image';
import Link from 'next/link';
import { MouseEvent } from 'react';

interface ProductColorTagProps {
  color: string;
  imageUrl: string;
  isSelectedVariant: boolean;
  isDisabled: boolean;
  url?: string;
  onClick?: (event: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => void;
  isQuickView?: boolean;
}

const ProductColorTag = ({
  color,
  imageUrl,
  isSelectedVariant,
  isDisabled,
  url,
  onClick,
  isQuickView = false,
}: ProductColorTagProps) => {
  const content = (
    <Image
      loader={amplienceImageLoader}
      width={32}
      height={32}
      loading="lazy"
      src={imageUrl}
      alt={color}
      className={cn('cursor-pointer rounded-full', {
        'cursor-not-allowed': isDisabled,
        'w-8 h-8': !imageUrl
      })}
    />
  );

  if (url) {
    return (
      <li
        className={cn({
          'cursor-not-allowed': isDisabled,
        })}
      >
        <Link
          aria-disabled={isDisabled}
          href={url}
          aria-label={`${color}-color`}
          className={cn('flex shrink-0 items-center justify-center rounded-full border-2 p-[2px]', {
            'border-black': isSelectedVariant,
            'cursor-not-allowed': isDisabled,
          })}
          onClick={(e) => {
            e.preventDefault();
            if (!isDisabled && !isQuickView) {
              window.history.replaceState({ shallow: true }, '', url);
            }
          }}
        >
          {content}
        </Link>
      </li>
    );
  }
  return (
    <li
      aria-label={`${color}-color`}
      onClick={onClick}
      className={cn('flex items-center justify-center rounded-full border-[1px] border-transparent p-[2px]', {
        'h-7 w-7': !isQuickView,
        'border-black': isSelectedVariant,
      })}
    >
      <div
        className={cn('shrink-0', {
          'h-[22px] w-[22px]': !isQuickView,
        })}
      >
        {content}
      </div>
    </li>
  );
};

export default ProductColorTag;
